import React, { useState, useRef, useEffect } from "react";
import { withRouter } from "react-router-dom";
import config from "config";
import * as api from "core-module/services/api";
import logo from "assets/img/mcsnetLogo.png";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import LoadingBox from "common/components/LoadingBox";
import Button from "common/components/CustomButtons/Button";
import withStyles from "@material-ui/core/styles/withStyles";

const getVar = function (variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const styles = {
  logo: {
    maxWidth: "calc(100px + 20vmin)",
    marginTop: "calc(10px + 10vmin)",
  },
  message: {
    maxWidth: "1000px",
    marginTop: "50px",
    marginBottom: "50px",
    paddingLeft: "50px",
    paddingRight: "50px",
    fontSize: "calc(10px + 2vmin)",
  },
};

const RegisterLayout = (props) => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Error");
  const [animation, setAnimation] = useState(0);
  const [redirect, setRedirect] = useState(false);
  const [showGoToMyaccount, setShowGoToMyaccount] = useState(false);

  const { classes, history } = props;

  useInterval(() => {
    if (animation !== 0) {
      if (animation === 3) {
        setAnimation(1);
      } else {
        setAnimation(animation + 1);
      }
    }
  }, 800);

  useEffect(() => {
    const hw = getVar("hw");
    const seg = getVar("seg");

    if (
      history.location.search !== null &&
      history.location.search.length > 0
    ) {
      history.push(history.location.pathname, history.location.state);
    }

    let fetchID;
    let redirectID;

    if (hw !== false || seg !== false) {
      api
        .post("me.1/firstmacregister", { hw, seg })
        .then((r) => {
          if (!("case" in r) || r.case < 100) {
            setLoading(false);
            setRedirect(true);
            if ("message" in r) {
              setMessage(r.message);
            } else {
              setMessage(
                "Error in register. Please contact MCSnet. Toll Free Number: 1-866-390-3928 / Email: support@mcsnet.ca / Address: 4810 50th Ave, PO Box 98, St Paul, AB T0A3A0"
              );
            }
            setShowGoToMyaccount(true);
          } else {
            setLoading(false);
            setMessage(
              "Please wait while we automatically setup your connection."
            );
            setAnimation(1);

            let done = false;
            fetchID = setInterval(() => {
              if (done === false) {
                api.get("me.1/whatismyipaddress");
              }
            }, 5000);
            redirectID = setTimeout(() => {
              history.push(config.MYACCOUNT.APP_PATH + "/");
            }, 120000);
          }
        })
        .catch((e) => {
          setLoading(false);
          setShowGoToMyaccount(true);
          setMessage(e.message);
        });
    } else {
      setShowGoToMyaccount(true);
      setLoading(false);
      setMessage(
        "Register failed. Please contact MCSnet. Toll Free Number: 1-866-390-3928 / Email: support@mcsnet.ca / Address: 4810 50th Ave, PO Box 98, St Paul, AB T0A3A0"
      );
    }

    return () => {
      clearInterval(fetchID);
      clearInterval(redirectID);
    };
  }, [history]);

  if (loading) {
    return <LoadingBox />;
  } else {
    return (
      <GridContainer align="center">
        <GridItem xs={12}>
          <img className={classes.logo} src={logo} alt="mcsnet-logo" />
        </GridItem>
        <GridItem xs={12}>
          <h2 className={classes.message}>{message}</h2>
        </GridItem>
        <GridItem xs={12}>
          {redirect || showGoToMyaccount ? (
            <Button
              key="redirectbutton"
              color="primary"
              onClick={() => {
                history.push(config.MYACCOUNT.APP_PATH + "/");
              }}
            >
              Click here to go to your account
            </Button>
          ) : null}
        </GridItem>
        <GridItem xs={12}>
          {animation > 0 ? (
            animation > 1 ? (
              animation > 2 ? (
                <h1>. . .</h1>
              ) : (
                <h1>. . </h1>
              )
            ) : (
              <h1>.</h1>
            )
          ) : null}
        </GridItem>
      </GridContainer>
    );
  }
};

export default withStyles(styles)(withRouter(RegisterLayout));
